import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { authApi } from '../..'
import { GetUserRequest, GetUserResponse } from './getUser.types'

export const getUser = async (request: GetUserRequest) => {
  const response = await authApi.get<GetUserResponse>(`/users/${request.id}`)
  return response.data
}

export const GET_USER_QUERY_KEY = 'getUser'

export const useGetUserQuery = (
  request: GetUserRequest,
  options?: ExtendableQueryOptions<GetUserResponse>
) => {
  return useQuery({
    queryKey: [GET_USER_QUERY_KEY, request.id],
    queryFn: () => getUser(request),
    ...options
  })
}
